import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(theme => ({
  root: {
    position: 'relative',
    display: 'grid',
    placeItems: 'center',
    borderRadius: '8px',
    minWidth: '64px',
    width: '64px',
    maxWidth: '64px',
    minHeight: '64px',
    height: '64px',
    maxHeight: '64px',
    background: theme.palette.primary.main
  }
}))

export default useStyles
